<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
<div style="page-break-inside: avoid">
            <h5>{{ title}}</h5>
    <table class="optionalComponentSectionTable">
        <tr style="font-weight: bold;">
            <td>Well Type</td>
            <td>Count</td>
        </tr>

        <tr *ngFor="let w of wells">
            <td>{{ w.type }}</td>
            <td>{{ w.count }}</td>
        </tr>
    </table>
</div>
</ng-template>

<ng-template #template_mobile let-title="title">
<div style="page-break-inside: avoid">
    <h5>{{ title}}</h5>
    <table class="optionalComponentSectionTable">
        <tr style="font-weight: bold;">
            <td>Well Type</td>
            <td>Count</td>
        </tr>

        <tr *ngFor="let w of wells">
            <td>{{ w.type }}</td>
            <td>{{ w.count }}</td>
        </tr>
    </table>
</div>
</ng-template>